import React from "react";
import { Spinner, Text, Tooltip } from "@fluentui/react-components";
import { FolderRegular } from "@fluentui/react-icons";
import { FolderSearchResult } from "../../../types/filing";
import {
  searchStatusClass,
  searchResultsListClass,
  searchResultItemClass,
  searchResultItemSelectedClass,
  searchResultTextClass,
  searchResultNameClass,
  searchResultPathClass,
  searchTooltipContentClass,
  searchTooltipSegmentClass,
} from "./styles";

type FolderSearchResultsProps = {
  results: FolderSearchResult[];
  selectedId: string | null;
  onSelect: (id: string, name: string, path?: string) => void;
  isLoading: boolean;
};

const FolderSearchResults: React.FC<FolderSearchResultsProps> = ({
  results,
  selectedId,
  onSelect,
  isLoading,
}) => {
  if (isLoading && results.length === 0) {
    return (
      <div className={searchStatusClass}>
        <Spinner size="tiny" />
        <Text size={200}>Searching folders…</Text>
      </div>
    );
  }

  if (!isLoading && results.length === 0) {
    return (
      <div className={searchStatusClass}>
        <Text size={200}>No folders found</Text>
      </div>
    );
  }

  return (
    <ul
      role="listbox"
      aria-label="Folder search results"
      className={searchResultsListClass}
    >
      {results.map((item) => {
        const isSelected = selectedId === item.folder.id;
        const showPath = item.path.length > 1;
        const li = (
          <li
            key={item.folder.id}
            role="option"
            aria-selected={isSelected ? "true" : "false"}
            className={isSelected ? searchResultItemSelectedClass : searchResultItemClass}
            onClick={() => onSelect(item.folder.id, item.folder.displayName, item.pathString)}
          >
            <FolderRegular />
            <div className={searchResultTextClass}>
              <span className={searchResultNameClass}>{item.folder.displayName}</span>
              {showPath && (
                <span className={searchResultPathClass}>{item.pathString}</span>
              )}
            </div>
          </li>
        );
        const tooltipContent = (
          <span className={searchTooltipContentClass}>
            {item.path.map((segment, i) => (
              <span key={i} className={searchTooltipSegmentClass}>{i > 0 && <><wbr />{" > "}</>}{segment}</span>
            ))}
          </span>
        );
        return showPath ? (
          <Tooltip key={item.folder.id} content={tooltipContent} relationship="description" positioning="below">
            {li}
          </Tooltip>
        ) : li;
      })}
    </ul>
  );
};

export default FolderSearchResults;
